import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable no-param-reassign */

/**
 * Copies propTypes from Ancestor to Component, omitting some of the params
 */
export var inheritPropTypes = function inheritPropTypes(Component, Ancestor) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$omit = _ref.omit,
    omit = _ref$omit === void 0 ? [] : _ref$omit;
  Component.propTypes = _objectSpread({}, Ancestor.propTypes);
  Component.defaultProps = _objectSpread({}, Ancestor.defaultProps);
  omit.forEach(function (propName) {
    delete Component.propTypes[propName];
    delete Component.defaultProps[propName];
  });
  return Component;
};